// LTV-3054
// temporary hack for the commitment plan tests to minimize backend work
// these IDs and related checks should be removed in favor of plan permissions in the future

export const COMMITMENT_PLAN_IDS = [
  20091,
  20092,
  20093,
  20094,
  20095,
  20096,
  20097,
  20098,
  20099,
  20100,
  20112,
  20113,
  20114,
  20115,
  20116,
  20117,
  20118,
  20119,
  20120,
  20121,
  24440,
  24441,
  24557,
  24558,
  24619,
  24621,
  24706,
  24871,
  24872,
  24873,
  24874,
];
